// developed by Param Partap Singh
import React from 'react'
import Nav from '../Utils/Nav'
import banner from '../Assets/background2.JPG'
import '../Css/Software.css'
import vpnusing from '../Assets/vpn-using.pdf'
import Footer from '../Utils/Footer'

import Instruction from "../Assets/shared_comsol install-new.pdf"
import Instruction52 from "../Assets/Comsol52_Installation_Instruction.pdf"

import link1 from "../Assets/🪟 Mathematica 14.2.pdf"
import link2 from "../Assets/Mathematica 14.2_linux installation process.pdf"




// import download from "../../../public/Download"

export default function Software() {

    const handleDownload = () => {
        // APK file location relative to public folder
        const fileUrl = '/var/www/html/software/COMSOL52_dvd';
    
        // Create an invisible <a> element to trigger the download
        const link = document.createElement('a');
        link.href = fileUrl;
        link.download = 'COMSOL52_dvd';  // Optional: specify the name of the file
        link.click(); // Trigger the download
      };



  return (
    <>
    <Nav/>
    <div className="main-container">
        <div className="banner">
            <img className="background" src={banner} alt="" />
        <h1 className="main-heading-title">Software Repository</h1>
        </div>


        <div className="table-content">
            <table>
                <tr>
                    <th>S.No</th>
                    <th>Software Name</th>
                    <th>Description</th>
                    <th style={{width:"100px"}}>Version</th>
                    <th>Open source Equivalent</th>
                    <th>Download Link</th>
                </tr>

                
                <tr>
                    <td>1.</td>
                    <td>WebEx</td>
                    <td>Webex Meetings offers secure, integrated audio, video, and content sharing from any device, anywhere. Intelligent features such as noise removal, Webex Assistant, with real-time translations and People Insights automate meeting tasks to help you work smarter.</td>
                    <td>2019</td>
                    <td>BBB, Jitsi</td>
                    <td>The users webex account will be activated by competent authorities after sending email to <b>itteam@iitrpr.ac.in</b></td>
                </tr>


                <tr>
                    <td>2.</td>
                    <td>MATLAB</td>
                    <td>
                        <ul>
                            <li>Create an account using your iitrpr mail id from <a href="https://in.mathworks.com/academia/tah-portal/indian-institute-of-technology-ropar-1117203.html" target='_blank'>Click Here</a> </li>
                            <li>Download the latest version of Matlab.</li>
                            {/* <li>Please get activation key from IT Section(itteam@iitrpr.ac.in).</li> */}
                        </ul>
                    </td>
                    <td>Latest</td>
                    <td>Octave, Scilab</td>
                    <td><a href="https://in.mathworks.com/downloads/" target='_blank'>Click Here</a></td>
                    {/* <td><a href="https://in.mathworks.com/mwaccount/account/create?uri=%2Fmwaccount%2F" target='_blank'>Click Here</a></td> */}
                </tr>

                {/* <tr>
                    <td>3.</td>
                    <td>Camtasia</td>
                    <td>Camtasia is a software suite, created and published by TechSmith,for creating video tutorials and presentations directly via screencast, or via a direct recording plug-in to Microsoft PowerPoint.Audio or other multimedia recordings may be recorded at the same time or added separately from another source.</td>
                    <td>2019</td>
                    <td>
                        <ul>
                            <li>Installation Instructions For Camtasia On Window <a href="https://support.techsmith.com/hc/en-us/articles/203730428-How-to-Install-Camtasia-on-Windows" target='_blank'>Click Here</a>.</li>
                            <li>Installation Instructions For Camtasia On macOS <a href="https://support.techsmith.com/hc/en-us/articles/203727608-Installation-Instructions-For-Camtasia-On-macOS" target='_blank'>Click Here</a>.</li>
                        </ul>
                    </td>
                     
                </tr> */}
                
                <tr>
                    <td>3.</td>
                    <td>COMSOL</td>
                    <td>COMSOL Multiphysics is a cross-platform finite element analysis,solver and multiphysics simulation software.It allows conventional physics-based user interfaces and coupled systems of partial differential equations.</td>
                    <td>5.2 / 6.3 / 6.4 </td>
                    <td>OpenModelica</td>
                    <td> COMSOL 5.2 <a href="http://172.30.4.199/software-repo/COMSOL/COMSOL_52/"target='_blank'>Click Here</a> <br />  COMSOL 6.3 <a href="http://172.30.4.199/software-repo/COMSOL/COMSOL_63/"target='_blank'>Click Here</a> <br /> 
                     COMSOL 6.4 <a href="http://172.30.4.199/software-repo/COMSOL/COMSOL_64/"target='_blank'>Click Here</a> <br /> 
                    
                    License Server IP: 172.30.8.108 <br />
                     Installation Instructions 5.2 <a href={Instruction52} target='_blank'>Click Here</a> <br /> Installation Instructions 6.3 <a href={Instruction} target='_blank'>Click Here</a> </td>
                </tr>

                <tr>
                    <td>4.</td>
                    <td>MATHEMATICA</td>
                    <td>	Mathematica is a software system with built-in libraries for severalareas of technical computing that allow machine learning, statistics, symbolic computation, manipulating matrices, plotting functions and various types of data,Implementation of algorithms, creation of user interfaces, and interfacing with programs written in other programming.</td>
                    <td>11.3 / 14.3</td>
                    <td>Sage, Maxima</td>
                    {/* <td>License server installed in TC , Connection through VPN for TC network <a href={vpnusing} target='_blank'>Click Here</a> (license server IP is 10.20.0.247)</td> */}
                    <td> MATHEMATICA 11.3 <a href="http://172.30.4.199/software-repo/Mathematica/" target='_blank'>Click Here</a> <br /> 
                    MATHEMATICA 14.2/14.3 <a href="http://172.30.4.199/software-repo/Mathematica/" target='_blank'>Click Here</a> <br />
                    License Server IP 11.3: 172.30.8.32 <br />
                    License Server IP 14.2/14.3: 172.30.8.63 <br />
                    Installation Instructions 14.2/14.3 for windows <a href={link1} target='_blank'>Click Here</a> <br />
                    Installation Instructions 14.2/14.3 for Linux <a href={link2} target='_blank'>Click Here</a>

                    </td>
                </tr>

                <tr>
                    <td>5.</td>
                    <td>ANSYS</td>
                    <td>	ANSYS is a powerful, widely-used engineering simulation software suite developed by ANSYS Inc. It is primarily used for finite element analysis (FEA), computational fluid dynamics (CFD), thermal analysis, electromagnetics, and multiphysics simulations. Engineers and researchers use ANSYS to simulate how products will behave under real-world conditions, allowing for better design, testing, and optimization—often before anything physical is built.</td>
                    <td>2025.R1</td>
                    <td>GMSH, OpenFOAM</td>
                    <td> ANSYS 2025.R1 <a href="http://172.30.4.199/software-repo/Ansys/" target='_blank'>Click Here</a> <br />
                    License Server IP: 172.30.8.58 <br/>
                    Kindly Contact to IT Team for Installation Instructions. 
                    </td>
                </tr>

                <tr >
                    <td>6.</td>
                    <td> Maple</td>
                    <td>Maple is a symbolic and numeric computing software used for mathematical modeling, solving equations, data analysis, visualization, and programming. It’s widely used in academia and engineering.</td>
                    <td>2024.2</td>
                    <td>Sage, Maxima</td>
                    <td>  Maple 2024.2 <a href="http://172.30.4.199/software-repo/Maple/" target='_blank'>Click Here</a> <br />
                    Kindly contact to IT Team for Key.
                    </td>
                </tr>

 

            </table>
        </div>
    </div>
    <Footer/>
    </>
  )
}
